// deps
import React, { ReactElement } from "react";
import { Checkbox, CHECKBOX_ACCENT } from "@swiggy-private/core-ui";
import cx from "classnames";

// test-ids
import { ADD_NEW_CARD_TEST_IDS } from "@swiggy-private/payment-test-ids";

// styles
import styles from "../AddNewCard.v4.scss";
interface AddNewCardSaveDetailsProps {
    selected: boolean;
    title: string;
    isHidden?: boolean;
    titleLink?: string;
    subTitle?: string;
    subTitleLink?: string;
    onClick: VoidFunction;
    onInfoClick: (e: React.MouseEvent) => void;
}

const checkboxAttrs = {
    "data-testid": ADD_NEW_CARD_TEST_IDS.SELECTION_CARD_CHECKBOX,
};

function SelectionCard({
    title,
    titleLink,
    subTitle,
    subTitleLink,
    selected,
    isHidden,
    onClick,
    onInfoClick,
}: AddNewCardSaveDetailsProps): ReactElement {
    const styleContainer = cx(styles.newCardSelectionCard, {
        [styles.newCardSelectionCardHidden]: isHidden,
    });

    return (
        <div className={styleContainer}>
            <div className={styles.newCardSelectionCardCheckbox}>
                <Checkbox
                    name={title}
                    accent={CHECKBOX_ACCENT.SWIGGY_ORANGE}
                    checked={selected}
                    onChange={onClick}
                    attrs={checkboxAttrs}
                />
            </div>

            <div className={styles.newCardSelectionCardText}>
                <div
                    className={styles.newCardSelectionCardTitleText}
                    data-testid={ADD_NEW_CARD_TEST_IDS.SELECTION_CARD_TEXT}
                >
                    {title}
                    {titleLink && (
                        <span className={styles.newCardSelectionCardTitleTextInfo} onClick={onInfoClick}>
                            {titleLink}
                        </span>
                    )}
                </div>
                <div
                    className={styles.newCardSelectionCardSubTitleText}
                    data-testid={ADD_NEW_CARD_TEST_IDS.SELECTION_CARD_SUB_TEXT}
                >
                    {subTitle}
                    {subTitleLink && (
                        <span className={styles.newCardSelectionCardSubTitleTextInfo} onClick={onInfoClick}>
                            {subTitleLink}
                        </span>
                    )}
                </div>
            </div>
        </div>
    );
}

export default React.memo(SelectionCard);
